import React, { memo } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthState } from "./useAuthState";

interface ConditionalRouteProps {
  component: React.ComponentType<any>;
  isPrivate?: boolean;
}

const ConditionalRoute: React.FC<ConditionalRouteProps> = ({
  component: Component,
  isPrivate = false,
}) => {
  const { isAuthenticated } = useAuthState();

  if (isPrivate && !isAuthenticated) {
    const returnUrl =
      location.pathname +
      location.search +
      location.hash;

    return (
      <Navigate to="/auth/login"
        state={{ returnUrl }}
        replace
      />
    );
  }

  if (!isPrivate && isAuthenticated) {
    return (
      <Navigate to="/dashboard" replace />
    );
  }

  return (
    <Component>
      <Outlet />
    </Component>
  );
};

export default memo(ConditionalRoute);
